
import { Component, Vue, Prop } from 'vue-property-decorator'
@Component
export default class FormSubHeading extends Vue {
  @Prop({ type: String, required: true }) title!: string
}
